
import '../../../../assets/css/screens/serviceprovider/dashboard/notification/Notification.css';
import WorkerNavbar from '../../../../components/serviceprovider/workerdashboard/Workernavbar/WorkerNavbar';

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Calendar, DollarSign, CheckCircle, AlertTriangle, MessageSquare, Bell } from 'lucide-react';


// ── Notification data ─────────────────────────────────────────
const INITIAL_NOTIFICATIONS = [
  {
    id: 1,
    type: 'booking',
    title: 'New Booking Request',
    message: 'Sara Malik wants to book you for Electrical Wiring Fix',
    time: '2 min ago',
    isRead: false,
  },
  {
    id: 2,
    type: 'bid',
    title: 'Bid Accepted!',
    message: 'Your bid for Full House Cleaning has been accepted by Zara Sheikh',
    time: '1 hour ago',
    isRead: false,
  },
  {
    id: 3,
    type: 'payment',
    title: 'Payment Received',
    message: '$3,500 credited to your wallet for Kitchen Plumbing Repair',
    time: '3 hours ago',
    isRead: true,
  },
  {
    id: 4,
    type: 'reminder',
    title: 'Job Reminder',
    message: 'You have a job scheduled tomorrow at 10:00 AM - Electrical Wiring Fix',
    time: '5 hours ago',
    isRead: true,
  },
  {
    id: 5,
    type: 'wallet',
    title: 'Wallet Balance Low',
    message: 'Your wallet balance is below $1,000. Top up to continue accepting jobs.',
    time: '1 day ago',
    isRead: true,
  },
  {
    id: 6,
    type: 'message',
    title: 'New Message',
    message: 'Ahmed Khan sent you a message about the plumbing job',
    time: '1 day ago',
    isRead: true,
  },
];

// ── Icon + color config per type ──────────────────────────────
const TYPE_CONFIG = {
  booking:  { icon: <Calendar size={20} />,      iconColor: '#0491e1', iconBg: '#e8f4fd' },
  bid:      { icon: <CheckCircle size={20} />,    iconColor: '#10b981', iconBg: '#e6f9f2' },
  payment:  { icon: <DollarSign size={20} />,     iconColor: '#10b981', iconBg: '#e6f9f2' },
  reminder: { icon: <Bell size={20} />,           iconColor: '#f59e0b', iconBg: '#fff7e6' },
  wallet:   { icon: <AlertTriangle size={20} />,  iconColor: '#ef4444', iconBg: '#fef2f2' },
  message:  { icon: <MessageSquare size={20} />,  iconColor: '#0491e1', iconBg: '#e8f4fd' },
};

const WorkerNotifications = () => {
  const navigate = useNavigate();
  const [notifications, setNotifications] = useState(INITIAL_NOTIFICATIONS);

  const handleMarkRead = (id) => {
    setNotifications(prev =>
      prev.map(n => n.id === id ? { ...n, isRead: true } : n)
    );
  };

  const handleBack = () => navigate(-1);

  return (
    <div className="wn-page">


      {/* ════ MOBILE HEADER ════ */}
      <div className="wn-mob-header">
        <button className="wn-back-btn" onClick={handleBack}>
          <ArrowLeft size={22} />
        </button>
        <h2 className="wn-heading">Notifications</h2>
      </div>

      {/* ════ DESKTOP HEADING ════ */}
      {/* <div className="wn-desk-heading">
        <h1 className="wn-heading">Notifications</h1>
      </div> */}

      {/* ════ NOTIFICATIONS LIST ════ */}
      <div className="wn-list">
        {notifications.map((notif, index) => {
          const cfg = TYPE_CONFIG[notif.type] || TYPE_CONFIG.message;
          return (
            <div
              key={notif.id}
              className={`wn-card${!notif.isRead ? ' wn-card--unread' : ''}`}
              style={{ animationDelay: `${index * 0.06}s` }}
              onClick={() => handleMarkRead(notif.id)}
            >
              {/* Icon */}
              <div
                className="wn-icon"
                style={{ background: cfg.iconBg, color: cfg.iconColor }}
              >
                {cfg.icon}
              </div>

              {/* Content */}
              <div className="wn-content">
                <p className="wn-title">{notif.title}</p>
                <p className="wn-message">{notif.message}</p>
                <span className="wn-time">{notif.time}</span>
              </div>

              {/* Unread dot */}
              {!notif.isRead && <span className="wn-dot" />}
            </div>
          );
        })}
      </div>

    </div>
  );
};

export default WorkerNotifications;